<template>
    <input class="form-control" type="text" :name="nameOfPicker" value="">
</template>

<script>
let moment = require('moment')
export default {
  data () {
    return {
      start: '',
      end: ''
    }
  },
  props: {
    nameOfPicker: {
      required: true
    },
    startDate: {
      required: false
    },
    endDate: {
      required: false
    }
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    },
    initiateDateFilter () {
      return new Promise((resolve, reject) => {
        let $ = window.jQuery
        let tren = this
        $('input[name=' + tren.nameOfPicker + ']').daterangepicker({
          autoUpdateInput: true,
          timePicker: true,
          timePicker24Hour: true,
          locale: {
            cancelLabel: 'Clear',
            format: 'DD/MM/YYYY'
          },
          autoApply: true
        })
        $('input[name=' + tren.nameOfPicker + ']').on('apply.daterangepicker', function (ev, picker) {
          ev.stopPropagation()
          tren.$store.commit('updatePicker', tren.nameOfPicker)
          // tren.start = picker.startDate.format('YYYY-MM-DDTHH:mm:ss+0000')
          // tren.end = picker.endDate.format('YYYY-MM-DDTHH:mm:ss+0000')
          // TODO preveri ce pravilno deluje v poletnem casu
          var timezone = (-(new Date().getTimezoneOffset() / 60)).toString(10).padStart(2, '0')
          let value = {
            start: moment(picker.startDate).format('YYYY-MM-DDTHH:mm:ss+' + timezone + ':00'),
            end: moment(picker.endDate).format('YYYY-MM-DDTHH:mm:ss+' + timezone + ':00')
          }
          $(this).val(tren.formatPicker(value.start, value.end))
          tren.updateValue(value)
        })
        $('input[name=' + tren.nameOfPicker + ']').on('cancel.daterangepicker', function (ev, picker) {
          $(this).val('')
          tren.updateValue({
            start: '',
            end: ''
          })
        })
        resolve()
      })
    },
    formatPicker (startVal, endVal) {
      return moment(startVal).format('DD/MM/YYYY HH:mm') + ' - ' + moment(endVal).format('DD/MM/YYYY HH:mm')
    }
  },
  mounted () {
    this.initiateDateFilter()
    let picker = window.jQuery('input[name=' + this.nameOfPicker + ']')
    picker.val(this.formatPicker(moment(this.startDate), moment(this.endDate)))
  }
}
</script>




// WEBPACK FOOTER //
// DateRangePicker.vue?61bf3233